angular.module("vgresiduos").controller("RecipientListCtrl", [
	"$stateParams",
	"$rootScope",
	function ($stateParams, $rootScope) {
		"use strict";

		this.$onInit = function () {
			Vgr.util.redirectSingleton($rootScope, "unidade/acondicionamentos");
		};
	}
]);
